<template>
  <div>
    <formula-head :details="details" />
    <formula-base :details="details" />
    <!-- <formula-tabs /> -->
    <formula-add :rowId="formulaId" :factoryId="factoryId" :details="details" />
    <formula-additional-raw :rowId="formulaId" :factoryId="factoryId" />
  </div>
</template>

<script>
import FormulaHead from './BlendComponent/BlendHead.vue'
import FormulaBase from './BlendComponent/BlendBase.vue'
import FormulaAdd from './BlendComponent/BlendAdd.vue'
import FormulaAdditionalRaw from './BlendComponent/FormulaAdditionalRaw.vue'
import { getRequest } from "@/components/Common/Utils/Utils.js";
export default {
  components: {FormulaHead,FormulaBase,FormulaAdd,FormulaAdditionalRaw},
  data(){
    return {
      details: {},
      formulaId: getRequest('id'),
      factoryId: getRequest('factoryId'),
    }
  },
  mounted(){
    this.getDetail()
  },
  methods:{
    getDetail() {
      this.$http.get('/nhf-app/archivedFormula/detail',{params: {formulaId: this.formulaId}}).then(res => {
        if(res && res.data){
          this.details = res.data
        }
      })
    },
  }
}
</script>
